import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import Paper from 'material-ui/Paper'
import LoginForm from '../components/LoginForm'
import { logo, logoWhite, title } from '../config/constants'
import { auth, login } from '../helpers/auth'
import { pageLoaded } from './utils'

export default class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errorShown: false,
      errorText: '',
      loading: false
    }

    this.passwordLogin = this.passwordLogin.bind(this)
    this.signUp = this.signUp.bind(this)
    this.loginError = this.loginError.bind(this)
    this.hideError = this.hideError.bind(this)
  }

  componentDidMount() {
    pageLoaded('Login')
  }

  passwordLogin(user, pass) {
    this.setState({ loading: true })
    login(user, pass)
      .catch(err => this.loginError(err))
  }

  signUp(user, pass) {
    this.setState({ loading: true })
    auth(user, pass)
      .catch(err => this.loginError(err))
  }

  loginError(err) {
    this.setState({
      errorText: err.message,
      errorShown: true,
      loading: false
    })
  }

  hideError() {
    this.setState({ errorShown: false })
  }

  render() {
    const loader = (
      <div style={{
        alignItems: 'center',
        display: 'flex',
        height: '205px',
        justifyContent: 'center'
      }}>
        <CircularProgress color='#fff' size={80} thickness={5} />
      </div>
    )

    const loginForm = (
      <LoginForm
        login={this.passwordLogin}
        signUp={this.signUp}
      />
    )

    return (
      <div style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        position: 'fixed',
        top: '0',
        left: '0'
      }}>
        <Dialog
          actions={[
            <FlatButton
              label='Okay'
              onTouchTap={this.hideError}
            />
          ]}
          open={this.state.errorShown}
          onRequestClose={() => this.hideError()}
          title='Oops..'
        >
          {this.state.errorText}
        </Dialog>
        <div style={{
          display: window.screen.width > 768 ? 'flex' : 'none',
          flex: '10',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img
            role='presentation'
            src={logo}
            style={{ height: '35vh' }}
          />
          <h1 style={{
            fontSize: '5vh',
            fontWeight: '400',
            marginBottom: '0'
          }}>{title}</h1>
          <p style={{
            textAlign: 'center',
            width: '80%'
          }}>An InfoHart sample risk management application by Hartley Software.</p>
        </div>
        <Paper
          style={{
            background: '#f57c00',
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '350px',
            padding: '25px'
          }}
          zDepth={2}
        >
          <img src={logoWhite} style={{ width: '100px' }} role='presentation' />
          <h2 style={{ color: '#fff', fontWeight: '400' }}>{title}</h2>
          {this.state.loading ? loader : loginForm}
        </Paper>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/Login.js